import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import FloatingButton from "./FloatingButton.js";
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  badgeContent:{
    fontSize: 12,
    backgroundColor: '#f7941e'
  },
  badgeContentFloatinButton:{
    fontSize: 11,
    backgroundColor: '#f7941e',
    marginTop:-10,
    color: 'white'
  },
  shape: {
    backgroundColor: theme.palette.primary.main,
    width: 40,
    height: 40,
  },
  shapeCircle: {
    borderRadius: '50%',
  },
  iconSize:{
    fontSize:50,
    color:'#f7941e'
  },
}));

export default function SimpleBadge(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {props.type && props.type === 'floatingIcon'?
      <Badge classes={{ badge: classes.badgeContentFloatinButton }} badgeContent={props.badgeContent} >
        <FloatingButton handleFloatingContactForm={props.handleFloatingContactForm} floatingContactForm={props.floatingContactForm}/>
      </Badge>
      : props.type && props.type === 'circle'?
      <Badge>
        {<ChatBubbleIcon className={classes.iconSize}/>}
      </Badge>
      :
      <Badge classes={{ badge: classes.badgeContent }} badgeContent={"Free"} >
        {props.data}
      </Badge>
      }
      
    </div>
  );
}
